import Cascader from './Cascader';

export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/cascader/index.js
// module id = 348
// module chunks = 0